module.exports = __webpack_public_path__ + "assets/img/14_915_big.7acacb44.jpg";